import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {  useParams } from "react-router-dom";
import Menu from '../../components/Menu';
import Topo from '../../components/Topo';
import Aguarde from '../../components/Aguarde';
import api from '../../services/api';
import Swal from 'sweetalert2'
import moment from 'moment';


function calculaPrazo(dataaverbacao, pagas, quantidade) {
    if(quantidade == '0'){
        return '-';
    }
    var restant = `${(moment().diff(moment(dataaverbacao, 'YYYY-MM-DD'), 'months'))}`;
    if(restant >= quantidade) {
        restant = quantidade;
    }
    return `${restant} de ${quantidade}`
}

function calcularSaldoDevedor(parcela, jurosMensal, mesesTotal, parcelasPagas) {
    var jurosMensal = jurosMensal;
    if(jurosMensal == '0') {
        return '0';
    }
    if(parcela == '0.00') {
        return '0';
    }

    if(parcelasPagas >= mesesTotal) {
        return '0';
    }
    const checktotalparcel = Number(mesesTotal) - Number(parcelasPagas);
    var totalrestante = checktotalparcel * (parcela);
    console.log(`
        parcela: ${parcela}
        mesesTotal: ${mesesTotal}
        parcelasPagas: ${parcelasPagas}
    `);    


    return totalrestante.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    parcela = parseFloat(parcela);
    // var jurosMensal = jurosMensal.replace('.', ',')
    var jurosMensal = parseFloat(jurosMensal);

    console.log(`
        parcela: ${parcela}
        juros: ${jurosMensal}
        meses: ${mesesTotal}
        parcela paga: ${parcelasPagas}
        checktotalparcel: ${checktotalparcel}
        totalrestante: ${totalrestante}
    `);    
    // Convertendo a taxa de juros para formato decimal
    jurosMensal = jurosMensal / 100;

    // Calculando o saldo devedor com base nas parcelas pagas
    const saldoDevedor = parcela * ((Math.pow(1 + jurosMensal, mesesTotal) - Math.pow(1 + jurosMensal, parcelasPagas)) / jurosMensal);

    // Retorna o saldo devedor com 2 casas decimais
    return saldoDevedor.toFixed(2);
}
// function calcularSaldoDevedor(valorDivida, parcela, jurosMensal, mesesTotal, parcelasPagas) {
//     if(jurosMensal == '0') {
//         return '0';
//     }
//     if(valorDivida == '0.00') {
//         return '0';
//     }
//     console.log(`
//         valor divida: ${valorDivida}
//         parcela: ${parcela}
//         juros: ${jurosMensal}
//         meses total: ${mesesTotal}
//         parcelas pagas: ${parcelasPagas}
//     `);

//     // Converte a taxa de juros para formato decimal
//     jurosMensal = jurosMensal / 100;

//     // Calcula o saldo devedor com base nas parcelas pagas
//     const saldoDevedor = (valorDivida * Math.pow(1 + jurosMensal, mesesTotal)) - 
//                         (parcela * (Math.pow(1 + jurosMensal, mesesTotal) - Math.pow(1 + jurosMensal, parcelasPagas)) / jurosMensal);
//     console.log(saldoDevedor.toFixed(2), '>>> saldodevedor')
//     return saldoDevedor.toFixed(2); // Retorna o saldo devedor formatado com 2 casas decimais
// }
function calcularTaxaDeJurosOld(valorParcela, valorFinanciado, numParcelas) {
    return '-';
}

// function calcularValorFinal(parcela, jurosMensal, meses) {
//     console.log(`
//         parcela: ${parcela}
//         juros: ${jurosMensal}
//         meses: ${meses}
//     `);
    
//     // Corrigir jurosMensal para decimal
//     jurosMensal = jurosMensal / 100;

//     // Calculando o valor final com juros compostos
//     const valorFinal = parcela * ((Math.pow(1 + jurosMensal, meses) - 1) / jurosMensal);
//     return valorFinal.toFixed(2); // Retorna o valor final formatado com 2 casas decimais
// }

function calcularValorFinal(valorDivida, parcela, jurosMensal, meses) {
    if(valorDivida == '0.00') {
        return '0';
    }
//    console.log(valorDivida, 'valordivida>parcela: ', parcela);
    // Converte a taxa de juros para formato decimal
    jurosMensal = jurosMensal / 100;

    // Calcula o valor total a ser pago, multiplicando o valor da parcela pelo número de meses
    const valorTotal = parcela * meses;

    // Exibe as informações no console
    console.log(`
        Valor da Dívida: R$ ${valorDivida}
        Valor da Parcela: R$ ${parcela}
        Juros Mensais: ${jurosMensal * 100}%
        Prazo: ${meses} meses
        Valor Total a Pagar: R$ ${valorTotal.toFixed(2)}
    `);

    return valorTotal.toFixed(2).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }); // Retorna o valor total formatado
}

function calcularTaxaJuros(PV, PMT, n) {
    if(PV == '0.00') {
        return '0';
    }
    console.log(`pv: ${PV} - PMT: ${PMT} - N: ${n}`)
    // Função que calcula o valor presente a partir da taxa de juros
    function func(i) {
        return PV - (PMT * (1 - Math.pow(1 + i, -n)) / i);
    }

    // Usando uma técnica de busca numérica para encontrar a taxa de juros
    let i = 0.01; // Chute inicial
    let epsilon = 0.0001; // Precisão da solução
    let maxIter = 1000; // Número máximo de iterações
    let iter = 0;

    while (Math.abs(func(i)) > epsilon && iter < maxIter) {
        i = i - func(i) / (-(PMT * n * Math.pow(1 + i, -n - 1)) / i + (PMT * (1 - Math.pow(1 + i, -n)) / Math.pow(i, 2)));
        iter++;
    }

    let res = i * 100;
    let retorno = res.toFixed(2)
    if(retorno == '-Infinity') {
        return '-';
    } else {
        return retorno;
    }
//    return i * 100; // Retorna a taxa de juros em porcentagem
}


function calcularTaxaDeJuros(valorParcela, valorFinanciado, numParcelas) {
    let min = 0;
    let max = 1;
    let precisao = 0.00001;

    while (max - min > precisao) {
        let i = (min + max) / 2;
        let parcelaCalculada = (valorFinanciado * i) / (1 - Math.pow(1 + i, -numParcelas));

        if (parcelaCalculada < valorParcela) {
            min = i;  // Aumenta a taxa
        } else {
            max = i;  // Diminui a taxa
        }
    }

    return (min + max) / 2 * 100;  // Retorna a taxa de juros mensal em porcentagem
}


function Resultado(props){    
    const { doc } = useParams();
    const [dados, setDados] = useState({});
    const [loading, setLoging] = useState(0);
    const [error, setError] = useState(null);
    const Voltar = (e) => {
        e.preventDefault(0);
        window.location = '../Painel';
        return;
    }

    useEffect( () => {
        setLoging(1);
        async function getDados(){
            try{
                if(doc.length > 11) {
                    var dados = await api.get('api/cnpj/'+doc);

                } else {
                    var dados = await api.get('api/cpf/'+doc);
                }
            }catch(e){
                var dados = '';
                setLoging(0);
                setError('Indisponivel no momento.');
            }

            if(dados.data.msg === 'token invalido.'){
                setLoging(0);
                window.location = '../Sair';
                setError('Token invalido, refaça seu login.');
            }else if(dados.data.msg){
               // alert(dados.data.msg);
                Swal.fire(
                    'Atenção!',
                    dados.data.msg,
                    'error'
                  )
                  setLoging(0)
//              window.location = '../Painel';
            }else{
                if(dados.data === '"null"'){
                    
                    setLoging(0);
                    setError('Indisponivel no momento.');
        
                }else{
                    setDados(dados.data);                
                    setLoging(0);
                    setError(null);

                    document.getElementById('box').style.display = 'block';
                }
            }
        }
       getDados();

    }, [doc, setDados]);

    return (<div className="main-content">
        <Menu />
        <div id="page-wrapper">
            <Topo />
            {error !== null && <Aguarde id="loading" titulo="Ocorreu um erro, tente novamente em breve."/>}
            {loading > 0 && <Aguarde id="loading" titulo="Aguarde, carregando..."/>}
            <div id='box'>

      <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <ul className="nav nav-tabs" role="tablist" style={{marginTop: '0px'}}>
                <li role="presentation" className="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Dados cadastrais</a>
                </li>
            </ul>

            {dados.doc ? (<div className="tab-content">
                <div role="tabpanel" className="tab-pane active" id="home">
                    <div className="table-responsive" style={{marginTop: '12px'}}>
                        <table id="resultCadastro" className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong style={{marginRight: '11px'}}>CPF:</strong> 
                                        {dados.doc}
                                        <input type="hidden" name="doc" id="doc" value="99892030168"/>
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong style={{marginRight: '2px'}}>Nome:</strong> 
                                        {dados.nome}
                                    </td>
                                    <td>
                                        <strong>Sexo:</strong> 
                                        {dados.sexo === "M" ? "MASCULINO" : 'FEMININO'}
                                     </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Data de nascimento:</strong> 
                                        {dados.nascimento}
                                        
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Signo:</strong> 
                                        {dados.signo}										
                                    </td>
                                    <td colSpan="2">
                                        <strong>Nome da Mãe:</strong>
                                        {dados.mae}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>) :
            (<div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="home">
                <div className="table-responsive" style={{marginTop: '12px'}}>
                    <table id="resultCadastro" className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <strong style={{marginRight: '11px'}}>CNPJ:</strong> {dados.CNPJ}
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong style={{marginRight: '2px'}}>Razão social:</strong> {dados.RAZAO_SOCIAL}
                                </td>
                               
                            </tr>
                            <tr>
                                <td>
                                    <strong style={{marginRight: '2px'}}>Nome fantasia:</strong> {dados.NOME_FANTASIA}
                                </td>
                               
                            </tr>
                            <tr>
                            <td>
                                    <strong>Tipo:</strong> {dados.TIPO}
                                    
                                </td>
                                
                                
                            </tr>
                            <tr>
                            <td>
                                    <strong>Data de abertura:</strong> {moment(dados.DATA_FUNDACAO).format("DD/MM/YYYY") }
                                    
                                </td>
                            </tr>
                            <tr>
                            <td>
                                    <strong>Capital social:</strong> {dados.CAPITAL_SOCIAL}
                             
                                </td>
                                
                            </tr>
                            
                            <tr>
                               
                                <td>
                                    <strong>Natureza juridica</strong> {dados.NAT_JURIDI}
                                </td>
                            </tr>
                            <tr>
                               
                                <td>
                                    <strong>CNAE</strong> {dados.CNAE}
                                </td>
                            </tr>
                            <tr>
                               
                                <td>
                                    <strong>CNAE secudnario</strong> {dados.CNAE_SG}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>)
            }
        </div>
    </div>

    {typeof dados.obito != 'undefined' ? (<div className="row" style={{display: 'block'}}>
          <div className="col-md-10 col-md-offset-1">
            <ul className="nav nav-tabs" role="tablist">
                <li role="presentation" className="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Dados extras</a>
                </li>
            </ul>
        
        
        <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="home">
                <div className="table-responsive">
                    <table id="mytable" className="table table-bordred table-striped">
                        <tbody>
                                                                                                     <tr>
                                <td>
                                    <strong>Obito:</strong>
                                    <span id="resultrPlus"> 
                                        <button style={{height: '18px', fontSize: '11px', paddingTop: '0px', marginLeft: '5px'}} class="btn btn-primary" type="button" onClick={() => window.open('https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp?cpf='+dados.doc+'&nascimento=' + dados.nascimento, '_blank')}>Consultar Online</button>
                                    </span>
                                </td>
                              </tr>
                                                                                                       <tr>
                                <td>
                                    <strong>Numero RG:</strong>
                                    <span id="resultrPlus"> {dados.rg ? dados.rg : 'NADA ENCONTRADO'}</span>
                                </td>
                              </tr>
                                                                   
                                <tr>
                                  <td>
                                      <strong>Titulo:</strong>
                                      <span id="resultrPlus"> {dados.titulo ? dados.titulo : 'NADA ENCONTRADO'}</span>
                                  </td>
                                </tr>
                                
                                                                      <tr>
                                  {/* <td>
                                      <strong>Renda:</strong>
                                      <span id="resultrPlus"> {dados.renda ? dados.renda : 'NADA CONSTA'}</span>
                                  </td> */}
                                </tr>
                                
                                <tr>
                                  <td>
                                      <strong>Classe social:</strong>
                                      <span id="resultrPlus"> {dados.classe ? dados.classe : 'NADA ENCONTRADO'}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                      <strong>Profissão:</strong>
                                      <span id="resultrPlus"> {dados.profissao_titulo ? dados.profissao_titulo : ''} - CBO {dados.profissao ? dados.profissao : ''}</span>
                                  </td>
                                </tr>
                                
                                                                                                                  <tr>
                                    <td>
                                        <strong>Escolaridade:</strong>
                                        <span id="resultrPlus"> {dados.escolaridade ? dados.escolaridade : 'NADA ENCONTRADO'}</span>
                                    </td>
                                  </tr>
                                     
                                                                           <tr>
                                    <td>
                                        <strong>Bolsa Familia:</strong>
                                        <span id="resultrPlus"> {dados.bolsa_familia !== "0" ? dados.bolsa_familia : 'NADA ENCONTRADO'}</span>
                                    </td>
                                  </tr>
                                     
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>) : (``)}

{typeof dados.beneficios != 'undefined' ? (<div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active"><a href="#doc" aria-controls="doc" role="tab" data-toggle="tab" className="tab-result">Empréstimo(s)</a></li>
                        </ul>
                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <div className="table-responsive">
                                    <table id="mytable" className="table table-bordred table-striped">
                                        
                                        <tbody>
                                        {String((dados.beneficios  || []).length) == '0' ? (
                                                    <tr>
                                                        <td colSpan={10}>
                                                            Nada encontrado.
                                                        </td>
                                                    </tr>
                                                  ) : ``}
                                            {/* {console.log(typeof dados.emprestimos)} */}
                                            {typeof dados.beneficios != 'undefined' && Object.values(dados.beneficios ?? []).map((number) => (
                                                <>
                                            <div key={number.nb} style={{minWidth: '800px'}}>
                                                {/* <div style={{ padding: '10px', fontWeight: 'bold'}}>#Emprestimos</div> */}
                                                <br/>
                                                <div style={{ padding: '10px', fontWeight: 'bold'}}>
                                                    <span>#NB: {number.nb}</span> - <span>Especie: {number.esp}</span> - <span>Salario: {number.salario}</span> - <span style={{fontSize: '12px', fontWeight: 'normal'}}>
                                                    Salário tabela base 2021
                                                        {/* DIB: {moment(number.dib, "YYYYMMDD").format("DD/MM/YYYY")} */}
                                                        </span>
                                                </div>
                                                <table id="mytable" className="table table-bordred table-striped">
                                                <thead>
                                                <tr><th>Contrato</th>
                                                <th>Valor divida</th>
                                                <th>Valor Parcela</th>
                                                <th>Juros</th>
                                                <th>Prazo</th>
                                                <th>Inicio</th>
                                                <th>Fim</th>
                                                <th>Saldo devedor</th>
                                                <th>Valor final</th>
                                                <th>Banco</th>
                                                
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {String((dados.emprestimos  || []).length) == '0' ? (
                                                    <tr>
                                                        <td colSpan={10}>
                                                            Nada encontrado.
                                                        </td>
                                                    </tr>
                                                  ) : ``}
                                                    {/* {console.log(dados)} */}
                                                {dados.emprestimos && Object.keys(dados.emprestimos).map((key, emprestimoIndex) => {
                                                    const empres = dados.emprestimos[key];
                                                    return (
                                                        <tr key={emprestimoIndex} style={{borderBottom: '1px solid #000'}}>
                                                        <td>{empres.idcontrato}</td>
                                                        <td>R$ {empres.emprestado ?? (empres.valor ?? '')}</td>
                                                        <td>R$ {empres.parcela ?? (empres.valorparcela ?? '')}</td>
                                                        <td 
                                                        style={(calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? '') > 6 ? {color: 'red'} : ((calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? '') > 3 ? {color: 'tomato'} : {})}
                                                        >{
                                                        (calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? '')
                                                        }
                                                        
                                                         <span
                                                        style={(calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? '') == '-' ? {display: 'none'} : ((calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? '') > 3 ? {color: 'tomato', marginLeft: '-7px', display: 'block'} : {})}
                                                         id="resultrPlus">
                                                                <button onClick={() =>{
                                                                     window.open("https://www.bcb.gov.br/estatisticas/reporttxjuros?codigoSegmento=1&codigoModalidade=218101&historicotaxajurosdiario_atual_page=1&tipoModalidade=D&InicioPeriodo="+moment(empres.inicio ?? '').format("YYYY-MM-DD"), "_blank");
                                                                }} className="btn btn-primary" type="button" style={{height: '18px', fontSize: '11px', paddingTop: '0px', marginLeft: '5px'}}>Consultar Online</button>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {calculaPrazo(empres.dt_averbacao_consig, empres.parcelas_pagas, empres.quant_parcelas)}
                                                            
                                                            {/* {empres.parcelas_pagas ?? (empres.quant_parcelas ?? '')} de {empres.prazo ?? ''} ({empres.porcentagem_paga ?? ''}%) */}
                                                            </td>
                                                        <td>
                                                        {moment(empres.inicio ?? '').isValid() ? moment(empres.inicio).format("DD/MM/YYYY") : '-'}

                                                        {/* {moment(empres.inicio ?? '').format("DD/MM/YYYY") } */}
                                                        </td>
                                                        <td>
                                                        {moment(empres.fim ?? '').isValid() ? moment(empres.fim).format("DD/MM/YYYY") : '-'}

                                                        {/* {moment(empres.fim ?? '').format("DD/MM/YYYY") } */}
                                                        </td>
                                                        <td>
                                                        {calcularSaldoDevedor(
                                                        (empres.parcela ?? (empres.valorparcela ?? '')),
                                                        (calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? ''),
                                                        (empres.quant_parcelas ?? ''),
                                                        moment().diff(moment(empres.dt_averbacao_consig, 'YYYY-MM-DD'), 'months')
                                                        )}


{/*                                                         {calcularSaldoDevedor(
                                                            (empres.emprestado ?? (empres.valor ?? '')),
                                                            empres.parcela ?? (empres.valorparcela ?? ''),
                                                            (calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? ''),
                                                            (empres.quant_parcelas ?? '0'),
                                                            moment().diff(moment(empres.dt_averbacao_consig, 'YYYY-MM-DD'), 'months')
                                                            )} */}

                                                            

                                                        </td>
                                                        <td> 
                                                        {/* calcularValorFinal(valorDivida, parcela, jurosMensal, meses)  */}
                                                        R$ {calcularValorFinal((empres.emprestado ?? (empres.valor ?? '')), 
                                                            (empres.parcela ?? (empres.valorparcela ?? '')),
                                                        (calcularTaxaJuros(((empres.emprestado ?? (empres.valor ?? ''))), (empres.parcela ?? (empres.valorparcela ?? '')), (empres.quant_parcelas ?? '0')) ?? '')
                                                        , (empres.quant_parcelas ?? '0'))}</td>

                                                        <td>{empres.idbanco ?? ''}</td>


                                                        </tr>
                                                    
                                                    );
                                                    })}
                                                    </tbody>
                                               </table>
                                            </div>
                                            </>
                                            
                                            ))}
                                          
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
    </div>) : (``)}


{typeof dados.socios != 'undefined' ? (<div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Socio(s)</a></li>
                        </ul>
                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <div className="table-responsive">
                                    <table id="mytable" className="table table-bordred table-striped">
                                        <thead>
                                        <tr><th>DOC</th>
                                        <th>Nome</th>
                                        <th>Participação</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            
                                            {dados.socios && dados.socios.map((number) => (
                                                <>
                                            <tr><td>{number.CPF}</td>
                                            <td>{number.NOME}</td>
                                            <td>{number.PARTICIPACAO_SOCIO}</td></tr>
                                            </>
                                            ))}
                                          
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
    </div>) : (``)}

    {typeof dados.empresas != 'undefined' ? (<div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Empresa(s)</a></li>
                        </ul>
                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <div className="table-responsive">
                                    <table id="mytable" className="table table-bordred table-striped">
                                        <thead>
                                        <tr><th>CNPJ</th>
                                        <th>Razão social</th>
                                        <th>Participação</th>
                                        <th>Fundação</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {String((dados.empresas || []).length) == '0' ? (
                                                    <tr>
                                                        <td colSpan={4}>
                                                            Nada encontrado.
                                                        </td>
                                                    </tr>
                                        ) : ``}
                                            {dados.empresas && dados.empresas.map((number) => (
                                                <>
                                            <tr><td><a href={`../../../Resultado/${number.cnpj}`} target='_blank'>{number.cnpj}</a></td>
                                            <td>{number.razaosocial}</td>
                                            <td>{number.porcentagem}%</td>
                                            <td>{moment(number.fundacao).format("DD/MM/YYYY") }</td></tr>
                                            </>
                                            ))}
                                          
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
    </div>) : (``)}

    {typeof dados.parentes != 'undefined' ? (<div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Parente(s)</a></li>
                        </ul>
                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <div className="table-responsive">
                                    <table id="mytable" className="table table-bordred table-striped">
                                        <thead>
                                        <tr><th>DOC</th>
                                        <th>Nome</th>
                                        <th>Vinculo</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {String((dados.parentes || []).length) == '0' ? (
                                                    <tr>
                                                        <td colSpan={3}>
                                                            Nada encontrado.
                                                        </td>
                                                    </tr>
                                                  ) : ``}
                                            {dados.parentes && dados.parentes.map((number) => (
                                                <>
                                            <tr><td><a href={`../../../Resultado/${number.cpf}`} target='_blank'>{number.cpf}</a></td>
                                            <td>{number.nome}</td>
                                            <td>{number.vinculo}</td></tr>
                                            </>
                                            ))}
                                          
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
    </div>) : (``)}





                {typeof dados.cnaes != 'undefined' ? (<div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">CNAE(s)</a></li>
                        </ul>
                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <div className="table-responsive">
                                    <table id="mytable" className="table table-bordred table-striped">
                                        <thead>
                                        <tr><th>CNAE</th>
                                        <th>Descrição</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {dados.cnaes && dados.cnaes.map((number) => (
                                                <>
                                            <tr><td>{number.cnae}</td>
                                            <td>{number.descricao}</td>
                                            </tr>
                                            </>
                                            ))}
                                          
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>) : (``)}

        <div className="row">
      <div className="col-md-10 col-md-offset-1">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Telefone(s)</a></li>
        </ul>
        <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="home">
                <div className="table-responsive">
                    <table id="mytable" className="table table-bordred table-striped">
                        <thead>
                            <tr><th>Numero</th>
                        </tr></thead>
                        <tbody>
                        {String((dados.telefones || []).length) == '0' ? (
                                                    <tr>
                                                        <td colSpan={10}>
                                                            Nada encontrado.
                                                        </td>
                                                    </tr>
                                                  ) : ``}
                            {dados.telefones && dados.telefones.map( (number) => (
                            <tr><td>{typeof number.numero !='undefined' ? number.numero : (typeof number.DDD != 'undefined' ? `(${number.DDD}) ${number.TELEFONE}` : ``) }</td></tr>
                        )) }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div className="row">
      <div className="col-md-10 col-md-offset-1">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">E-mail(s)</a></li>
        </ul>
        <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="home">
                <div className="table-responsive">
                    <table id="mytable" className="table table-bordred table-striped">
                        <thead>
                            <tr><th>E-mail</th>
                        </tr></thead>
                        <tbody>
                        {String((dados.emails || []).length) == '0' ? (
                                                    <tr>
                                                        <td colSpan={1}>
                                                            Nada encontrado.
                                                        </td>
                                                    </tr>
                                                  ) : ``}
                            {dados.emails && dados.emails.map( (number) => (
                            <tr><td>{typeof number.EMAIL != 'undefined' ? number.EMAIL : `` }</td></tr>
                        )) }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
                
        <div className="row">
      <div className="col-md-10 col-md-offset-1">
        <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Endereço(s)</a></li>
        </ul>
        <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="home">
                <div className="table-responsive">
                    <table id="mytable" className="table table-bordred table-striped">
                        <thead>
                            <tr><th>Logradouro</th>
                            <th>Bairro</th>
                            <th>CEP</th>
                            <th>Cidade</th>
                            <th>UF</th>
                        </tr></thead>
                        <tbody>
                        {dados.enderecos && dados.enderecos.map( (number) => <tr><td>{ number.ENDERECO }</td><td>{ number.BAIRRO }</td><td>{ number.CEP }</td><td>{ number.CIDADE }</td><td>{ number.UF }</td></tr>) }                                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
        
{typeof dados.interesses != 'undefined' ? (<div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Interesse(s)</a></li>
                        </ul>
                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <div className="table-responsive">
                                    <table id="mytable" className="table table-bordred table-striped">
                                        <thead>
                                        <tr><th>Serviço</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {dados.interesses && Object.entries(dados.interesses).map(([key, empres], emprestimoIndex) => (
                                           
                                            <tr key={key}>
                                            <td colSpan={4}>
                                                <span style={{fontWeight: 'bold'}}>{key}:</span> {empres == '1' ? <span style={{fontWeight: 'bold', color: 'green'}}>Sim</span> : <span style={{fontWeight: 'bold', color: 'tomato'}}>Não</span>}</td>
                                            </tr>
                                        ))}
                                                                        
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>) : (``)}



</div></div>
<center>
    <br/>
    <button className="btn btn-primary" onClick={Voltar} type="button" name="nova_consulta" id="nova_consulta">Nova consulta</button>
    <br/><br/><br/><br/>
</center>
</div>);
}

export default Resultado;
